export function uniq(arr1: any[], by?: (item: any) => any) {
  let a = arr1;

  if (by) {
    a = arr1.map(by);
  }

  const filterMap: any = {};

  for (let item of a) {
    item = item.trim();
    if (!filterMap[item]) {
      filterMap[item] = item;
    }
  }

  return Object.keys(filterMap);
}
